module.exports = __webpack_public_path__ + "fonts/montserrat-latin-400-normal.5d169d5.woff2";